
import React from 'react';
import { ChevronLeft, ChevronRight, Maximize2 } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface GalleryControlsProps {
  imagesLength: number;
  onPrevious: () => void;
  onNext: () => void;
  onFullscreen?: () => void;
}

const GalleryControls = ({ 
  imagesLength, 
  onPrevious, 
  onNext, 
  onFullscreen 
}: GalleryControlsProps) => {
  const isMobile = useIsMobile();
  
  return (
    <>
      {imagesLength > 1 && (
        <button
          onClick={onPrevious}
          className={`absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-black/50 ${isMobile ? 'p-3' : 'p-2'} rounded-full hover:bg-black/70 transition-colors`}
          aria-label="Previous image"
        >
          <ChevronLeft className={`${isMobile ? 'h-7 w-7' : 'h-6 w-6'} text-white`} />
        </button>
      )}
      
      {!!onFullscreen && (
        <button
          onClick={onFullscreen}
          className={`absolute top-2 right-2 z-20 bg-black/50 ${isMobile ? 'p-2.5' : 'p-2'} rounded-full hover:bg-black/70 transition-colors`}
          aria-label="View fullscreen"
        >
          <Maximize2 className={`${isMobile ? 'h-6 w-6' : 'h-5 w-5'} text-white`} />
        </button>
      )}
      
      {imagesLength > 1 && (
        <button
          onClick={onNext}
          className={`absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-black/50 ${isMobile ? 'p-3' : 'p-2'} rounded-full hover:bg-black/70 transition-colors`}
          aria-label="Next image"
        >
          <ChevronRight className={`${isMobile ? 'h-7 w-7' : 'h-6 w-6'} text-white`} />
        </button>
      )}
    </>
  );
};

export default GalleryControls;
